<template>
  <div class="container">
    <TopHeader/>
    <SpMenuCover/>

    <router-view/>
    <Footer/>
    <LoadCover/>
    <ContactButton/>
  </div>
</template>

<script>
  import firebase_auth from '@/firebase';
  import TopHeader from "@/components/objects/layout/TopHeader";
  import Footer from "@/components/objects/layout/Footer";
  import SpMenuCover from "@/components/molecules/cover/SpMenuCover";
  import LoadCover from "@/components/molecules/cover/LoadCover";
  import ContactButton from "@/components/atoms/ContactButton";

  export default {
    name: 'InformationTemplate',

    components: {ContactButton, Footer, TopHeader, SpMenuCover, LoadCover},

    async mounted() {
      await firebase_auth.onAuth();
    },
  }
</script>

<style lang="scss">
  .container {
    min-height: 100%;
    display: grid;
    grid-template-rows: 15vh 1fr 10vh;
    overflow: hidden;
  }

  .header {
    height: 15vh;
    grid-row: 1;
    position: fixed;
  }

  .contents_wrapper {
    grid-row: 2;
    width: 100%;
    min-height: 80vh;
  }

  .footer {
    grid-row: 3;
  }

  @media screen and (max-width: 767px) {
    .container {
      grid-template-rows: 15vh 1fr 15vh;
    }
  }
</style>
